import { PlayerSizesTypes } from '../../../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../../../common/styles/variables';
import { flexColumn } from '../../../../../common/styles/flex';
import {
  GALLERY_VIDEO_EXTRA_LARGE_MARGINS_LEFT,
  GALLERY_VIDEO_LARGE_MARGINS_LEFT,
  GALLERY_VIDEO_PLACEHOLDER_EXTRA_LARGE_WIDTH,
  GALLERY_VIDEO_PLACEHOLDER_LARGE_WIDTH,
} from '../../../moreVideos.constants';

interface StylesObject {
  galleryVideoContainerStyle: { [key: string]: any };
  infoWrapperStyle: { [key: string]: any };
  titleStyle: { [key: string]: any };
  durationStyle: { [key: string]: any };
  imageStyle: { [key: string]: any };
}

interface GalleryVideoContainerStyleObject {
  cursor: string;
  position: string;
  extraLarge: { [key: string]: any };
  large: { [key: string]: any };
  transition: string;
}

const getFirstVideoMarginsLeft = (screenView: number, playerSize: PlayerSizesTypes, isEndOfList: boolean, endOfListLeftoverSpaceProduct: number): number => {
  const videoPlaceholderWidth = playerSize === 'large' ? GALLERY_VIDEO_PLACEHOLDER_LARGE_WIDTH : GALLERY_VIDEO_PLACEHOLDER_EXTRA_LARGE_WIDTH;
  const videoMarginsLeft = playerSize === 'large' ? GALLERY_VIDEO_LARGE_MARGINS_LEFT : GALLERY_VIDEO_EXTRA_LARGE_MARGINS_LEFT;
  const endOfListMarginsLeft = ((screenView - 2) * videoPlaceholderWidth) + (videoPlaceholderWidth * endOfListLeftoverSpaceProduct);
  const firstVideoMarginLeft = isEndOfList ? endOfListMarginsLeft : ((screenView - 1) * videoPlaceholderWidth) - videoMarginsLeft;
  return firstVideoMarginLeft;
};

const galleryVideoContainer = (playerSize: PlayerSizesTypes, isFirstVideoOnList: boolean,
  screenView: number, galleryViewLength: number, numberOfVideoSpaces: number): GalleryVideoContainerStyleObject => {
  const galleryScreenSwitch = isFirstVideoOnList && screenView !== 1;
  const endOfListLeftoverSpaceProduct = 1 - (numberOfVideoSpaces % 1);
  const isEndOfList = galleryViewLength - screenView + 1 <= numberOfVideoSpaces;
  const firstVideoMarginsLeft = getFirstVideoMarginsLeft(screenView, playerSize, isEndOfList, endOfListLeftoverSpaceProduct);

  return {
    cursor: 'pointer',
    position: 'relative',
    transition: '150ms',
    extraLarge: {
      width: '153px',
      minWidth: '153px',
      height: '86px',
      marginLeft: galleryScreenSwitch ? `-${firstVideoMarginsLeft}px` : `${GALLERY_VIDEO_EXTRA_LARGE_MARGINS_LEFT}px`,
    },
    large: {
      width: '120px',
      minWidth: '120px',
      height: '67px',
      marginLeft: galleryScreenSwitch ? `-${firstVideoMarginsLeft}px` : `${GALLERY_VIDEO_LARGE_MARGINS_LEFT}px`,
    },
  };
};

const image = {
  position: 'absolute',
  width: '100%',
  height: '100%',
};

const infoWrapper = {
  height: '100%',
  width: '100%',
  position: 'absolute',
  extraLarge: {
    ...flexColumn,
    justifyContent: 'space-between',
  },
  onHover: {
    backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.8) 19%, rgba(0, 0, 0, 0))',
  },
};

const title = {
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-word',
  WebkitLineClamp: '2',
  color: SITE_VARIABLES.COLORS.WHITE,
  margin: '8px 8px 0px 8px',
};

const duration = {
  display: 'none',
  extraLarge: {
    display: 'flex',
    alignSelf: 'flex-end',
    fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
    fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_TINY,
    color: SITE_VARIABLES.COLORS.WHITE,
    marginRight: '4px',
    marginBottom: '4px',
  },
};

export const getGalleryVideoStyleObject = (playerSize: PlayerSizesTypes, galleryVideoHovered: boolean,
  isFirstVideoOnList: boolean, screenView: number, galleryViewLength: number, numberOfVideoSpaces: number): StylesObject => {
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const galleryContainerStyle = galleryVideoContainer(playerSize, isFirstVideoOnList, screenView, galleryViewLength, numberOfVideoSpaces);

  return ({
    galleryVideoContainerStyle: [
      galleryContainerStyle,
      largeSize && galleryContainerStyle.large,
      extraLargeSize && galleryContainerStyle.extraLarge,
    ],
    imageStyle: [
      image,
    ],
    infoWrapperStyle: [
      infoWrapper,
      extraLargeSize && infoWrapper.extraLarge,
      galleryVideoHovered && infoWrapper.onHover,
    ],
    titleStyle: {
      ...title,
    },
    durationStyle: [
      duration,
      extraLargeSize && duration.extraLarge,
    ],
  });
};
